// extracted by mini-css-extract-plugin
export default {"option":"DefaultOption_option__NEHWg","header":"DefaultOption_header__HYwNq","alignCenter":"DefaultOption_alignCenter__azGI9","description":"DefaultOption_description__lPi0A"};